import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('johnDeereExportModal');

    return {
        AUTO_RESOLVED_DESCRIPTION: t('autoResolvedDescription'),
        CANCEL_BUTTON: t('cancelButton'),
        CLOSE_BUTTON: t('closeButton'),
        ERROR_GENERIC: t('errorGeneric'),
        ERROR_TITLE: t('errorTitle'),
        EXPORT_BUTTON: t('exportButton'),
        FIELDS_LABEL: t('fieldsLabel'),
        NO_FIELDS: t('noFields'),
        NO_ORGANIZATIONS: t('noOrganizations'),
        ORGANIZATIONS_LABEL: t('organizationsLabel'),
        PICKER_DESCRIPTION: t('pickerDescription'),
        RESOLVING: t('resolving'),
        RETRY_BUTTON: t('retryButton'),
        STEP_DONE: t('stepDone'),
        STEP_FILE_RESOURCE: t('stepFileResource'),
        STEP_MAP_LAYER: t('stepMapLayer'),
        STEP_SUMMARY: t('stepSummary'),
        STEP_UPLOAD: t('stepUpload'),
        SUCCESS_DESCRIPTION: t('successDescription'),
        SUCCESS_TITLE: t('successTitle'),
        SUCCESS_VIEW_LINK: t('successViewLink'),
        TITLE: t('title')
    };
};

export default useTranslation;
